import { generateUrl } from "@repo/fika-shared/src/lib/slug"
import { useParams } from "@solidjs/router"
import { getTitle } from "@/lib/get-title"
import { createMatrixParams } from "@/lib/matrix-params"

const SUBSCRIPTIONS_BASE_PATH = "/subscriptions" as const

interface ListParams {
  after: string
  before: string
}

const LIST_DEFAULTS: ListParams = {
  after: "",
  before: "",
}

export function createSubscriptionsRouter() {
  const params = useParams()
  const list = createMatrixParams(() => params.listParams, LIST_DEFAULTS)
  const manage = createMatrixParams(() => params.manageParams, LIST_DEFAULTS)

  function paths(listParams?: Partial<ListParams>) {
    const url = `${SUBSCRIPTIONS_BASE_PATH}${list.makeURL(listParams)}`

    return {
      url,
      manage: (manageParams?: Partial<ListParams>) => {
        const manageUrl = `${url}/manage${manage.makeURL(manageParams)}`
        return {
          subscription: (model: {
            id: string
            publicationName: string | null
          }) => `${manageUrl}/subscription/${model.id}`,
          url: manageUrl,
        }
      },
      post: (
        postModel: { id: string; title: string | null },
        cursor?: string,
      ) => {
        const id = generateUrl(getTitle(postModel.title), postModel.id)
        const params = cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""
        return `${url}/${id}${params}`
      },
    }
  }

  return {
    paths,
    listParams: list.matrixParams,
    manageParams: manage.matrixParams,
  }
}
